const TEXT = {
    APPLY_STEP5_TEXT_1:"请上传身份证",
    APPLY_STEP5_TEXT_2:"身份证（正面）",
    APPLY_STEP5_TEXT_3:"身份证（反面）",
    APPLY_STEP5_TEXT_4:"请上传营业执照",
    APPLY_STEP5_TEXT_5:"营业执照",
    APPLY_STEP5_TEXT_6:"提交"

};
export {
	TEXT
}












// WEBPACK FOOTER //
// ./src/config/page/cn/apply/step5/index.js